export default __webpack_public_path__ + "static/media/station.bb4141db.svg";